import { useCallback, useEffect, useState } from 'react';
import { DrawerNoHeader } from '../../../components/drawer/DrawerNoHeader'
import { TabsProfileUser } from './TabsProfileUser';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById } from '../../../redux/actions/users';
import { getAllPaymentByUserId } from '../../../redux/actions/payment';
import { Button } from '../../../components/buttons/Button';
import { AvatarWithInitials } from '../../../components/avatar/AvatarWithInitials';
import { optionsAllCourseListOpenByIdUser } from '../../../redux/actions/options';

export const DrawerProfileUser = ({
    isOpenDrawerProfile,
    toggleDrawerProfile,
    userId,
    onUserUpdated,
    refreshTable
}) => {
    const dispatch = useDispatch();
    const { userSelected, loadingUserSelected } = useSelector((state) => state.users);
    const { user } = useSelector((state) => state.user);
    const { _id: userLoggedId } = user;
    const [isEditingUserData, setIsEditingUserData] = useState(false);
    const [onSaveCallback, setOnSaveCallback] = useState(null);
    const [onCancelCallback, setOnCancelCallback] = useState(null);
    const [loadingSaving, setLoadingSaving] = useState(false);

    const [isStudentNotesFooter, setIsStudentNotesFooter] = useState(false);
    const [studentNotesSaveAction, setStudentNotesSaveAction] = useState(null);
    const [studentNotesCancelAction, setStudentNotesCancelAction] = useState(null);
    const [studentNotesFooterSaveLabel, setStudentNotesFooterSaveLabel] = useState('Guardar nota');
    const [studentNotesFooterLoading, setStudentNotesFooterLoading] = useState(false);

    const clearStudentNotesFooter = useCallback(() => {
        setIsStudentNotesFooter(false);
        setStudentNotesSaveAction(null);
        setStudentNotesCancelAction(null);
        setStudentNotesFooterLoading(false);
    }, []);

    // Datos del usuario (con validación para evitar undefined)
    const {
        firstName = '',
        secondName = '',
        lastName = '',
        secondSurname = '',
        typeUser = '',
        status = '',
        matricula = ''
    } = userSelected || {};

    useEffect(() => {
        if (isOpenDrawerProfile && userId) {
            dispatch(getUserById(userId))
        }
    }, [isOpenDrawerProfile, userId, dispatch]);

    useEffect(() => {
        if (isOpenDrawerProfile && userId) {
            dispatch(getAllPaymentByUserId(userId))
        }
    }, [isOpenDrawerProfile, userId, dispatch]);

    useEffect(() => {
        if (isOpenDrawerProfile && userId) {
            dispatch(optionsAllCourseListOpenByIdUser(userId));
        }
    }, [isOpenDrawerProfile, userId, dispatch]);

    return (
        <DrawerNoHeader
            isOpen={isOpenDrawerProfile}
            toggleDrawer={toggleDrawerProfile}
            direction='right'
            footer={
                isEditingUserData ? (
                    <div className='flex items-center justify-end gap-4 overflow-hidden'>
                        <Button
                            type="button"
                            variant="secondary"
                            disabled={loadingSaving}
                            onClick={() => onCancelCallback?.()}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="button"
                            variant="primary"
                            loading={loadingSaving}
                            onClick={() => onSaveCallback?.()}
                        >
                            Guardar
                        </Button>
                    </div>
                ) : isStudentNotesFooter ? (
                    <div className='flex items-center justify-end gap-4 overflow-hidden'>
                        <Button
                            type="button"
                            variant="secondary"
                            disabled={studentNotesFooterLoading}
                            onClick={() => studentNotesCancelAction && studentNotesCancelAction()}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="button"
                            variant="primary"
                            loading={studentNotesFooterLoading}
                            onClick={() => {
                                const out = studentNotesSaveAction && studentNotesSaveAction();
                                if (out && typeof out.then === 'function') void out;
                            }}
                        >
                            {studentNotesFooterSaveLabel}
                        </Button>
                    </div>
                ) : (
                    <div className='flex items-center justify-end gap-4 overflow-hidden'>
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={() => toggleDrawerProfile()}
                        >
                            Cerrar
                        </Button>
                    </div>
                )
            }
        >
            <div className='w-full flex flex-col h-full overflow-hidden'>
                {/* Card única con toda la información - Header Fijo */}
                <div className='w-full bg-white rounded-lg border border-gray-200 flex-shrink-0'>
                    {/* Header con gradiente */}
                    <div className='bg-gradient-to-r from-indigo-500 to-purple-600 p-4 rounded-t-lg'>
                        <div className='flex items-center space-x-3 md:space-x-4'>
                            {/* Avatar con iniciales si no hay imagen */}
                            <div className='relative flex-shrink-0'>
                                <AvatarWithInitials
                                    firstName={firstName}
                                    lastName={lastName}
                                    loading={loadingUserSelected}
                                    size="md"
                                />
                            </div>

                            {/* Información principal */}
                            <div className='flex-1 min-w-0'>
                                {loadingUserSelected ? (
                                    <>
                                        {/* Skeleton mejorado para nombre con shimmer effect */}
                                        <div className='flex items-center gap-2 mb-2 flex-wrap'>
                                            <div className='h-6 md:h-8 w-40 md:w-64 bg-white/30 rounded-lg animate-pulse relative overflow-hidden'>
                                                <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                            </div>
                                            <div className='hidden md:block h-6 w-16 bg-white/20 rounded-full animate-pulse'></div>
                                        </div>
                                        {/* Skeleton para badges de info - solo desktop */}
                                        <div className='hidden md:flex flex-wrap gap-2 mt-2'>
                                            <div className='h-8 w-32 bg-white/20 rounded-lg animate-pulse relative overflow-hidden'>
                                                <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                            </div>
                                            <div className='h-8 w-28 bg-white/20 rounded-lg animate-pulse relative overflow-hidden'>
                                                <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                            </div>
                                        </div>
                                        {/* Indicador de carga adicional */}
                                        <div className='flex items-center gap-2 mt-2'>
                                            <svg className="w-4 h-4 text-white/60 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            <span className='text-white/60 text-xs font-medium'>Cargando información...</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='flex items-center gap-2 flex-wrap'>
                                            {/* Nombre con loading */}
                                            {!firstName && !lastName ? (
                                                <div className='h-6 md:h-8 w-40 md:w-64 bg-white/30 rounded-lg animate-pulse relative overflow-hidden'>
                                                    <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                                </div>
                                            ) : (
                                                <h3 className='text-white font-bold text-lg md:text-xl lg:text-2xl capitalize tracking-tight truncate'>
                                                    {`${firstName} ${secondName ? secondName : ''} ${lastName} ${secondSurname ? secondSurname : ''}`.trim() || 'Usuario'}
                                                </h3>
                                            )}
                                            
                                            {/* Badge de estado - solo en desktop */}
                                            {!status ? (
                                                <div className='hidden md:block h-6 w-16 bg-white/20 rounded-full animate-pulse relative overflow-hidden'>
                                                    <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                                </div>
                                            ) : (
                                                <>
                                                    {status === 'activo' && (
                                                        <span className='hidden md:inline-flex items-center gap-1.5 bg-emerald-400/20 backdrop-blur-sm text-emerald-100 text-xs font-bold px-3 py-1 rounded-full border border-emerald-300/30 shadow-md'>
                                                            <span className='relative flex h-2 w-2'>
                                                                <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-300 opacity-75'></span>
                                                                <span className='relative inline-flex rounded-full h-2 w-2 bg-emerald-300'></span>
                                                            </span>
                                                            Activo
                                                        </span>
                                                    )}
                                                    {status === 'inactivo' && (
                                                        <span className='hidden md:inline-flex items-center gap-1.5 bg-gray-400/20 backdrop-blur-sm text-gray-100 text-xs font-bold px-3 py-1 rounded-full border border-gray-300/30 shadow-md'>
                                                            <span className='relative flex h-2 w-2'>
                                                                <span className='relative inline-flex rounded-full h-2 w-2 bg-gray-300'></span>
                                                            </span>
                                                            Inactivo
                                                        </span>
                                                    )}
                                                    {status === 'baja' && (
                                                        <span className='hidden md:inline-flex items-center gap-1.5 bg-red-400/20 backdrop-blur-sm text-red-100 text-xs font-bold px-3 py-1 rounded-full border border-red-300/30 shadow-md'>
                                                            <span className='relative flex h-2 w-2'>
                                                                <span className='relative inline-flex rounded-full h-2 w-2 bg-red-300'></span>
                                                            </span>
                                                            Baja
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                        {/* Info badges - solo en desktop */}
                                        <div className='hidden md:flex flex-wrap gap-2 mt-2'>
                                            {/* Badge de matrícula con loading */}
                                            {!matricula ? (
                                                <div className='h-8 w-32 bg-white/20 rounded-lg animate-pulse relative overflow-hidden'>
                                                    <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                                </div>
                                            ) : (
                                                <div className='inline-flex items-center gap-1.5 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-lg border border-white/30'>
                                                    <svg className="w-4 h-4 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                                                    </svg>
                                                    <span className='text-white text-sm font-semibold'>
                                                        {matricula}
                                                    </span>
                                                </div>
                                            )}

                                            {/* Badge de tipo de usuario con loading */}
                                            {!typeUser ? (
                                                <div className='h-8 w-28 bg-white/20 rounded-lg animate-pulse relative overflow-hidden'>
                                                    <div className='absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer'></div>
                                                </div>
                                            ) : (
                                                <div className='inline-flex items-center gap-1.5 bg-white/20 backdrop-blur-sm px-3 py-1 rounded-lg border border-white/30'>
                                                    <svg className="w-4 h-4 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                    </svg>
                                                    <span className='text-white text-sm font-semibold capitalize'>
                                                        {typeUser}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tabs - Ocupa el espacio restante con scroll */}
                <div className='flex-1 overflow-hidden'>
                    <TabsProfileUser
                        userId={userId ? userId : userLoggedId}
                        isOpen={isOpenDrawerProfile}
                        onEditModeChange={setIsEditingUserData}
                        onSaveCallbackChange={setOnSaveCallback}
                        onCancelCallbackChange={setOnCancelCallback}
                        onLoadingSavingChange={setLoadingSaving}
                        onUserUpdated={onUserUpdated}
                        refreshTable={refreshTable}
                        onStudentNotesFormActiveChange={setIsStudentNotesFooter}
                        onStudentNotesSaveActionChange={setStudentNotesSaveAction}
                        onStudentNotesCancelActionChange={setStudentNotesCancelAction}
                        onStudentNotesFooterSaveLabelChange={setStudentNotesFooterSaveLabel}
                        onStudentNotesFooterLoadingChange={setStudentNotesFooterLoading}
                        onClearStudentNotesFooter={clearStudentNotesFooter}
                    />
                </div>
            </div>
        </DrawerNoHeader>
    )
}
